<template>
  <a
    href="#"
    class="btn--slider text-lg rounded-lg px-4 py-2 mx-3 relative transition duration-150 ease-in text-dblue-500"
    :class="{ active: slide.isActive, paused: this.isPaused }"
    @click.prevent="changeTab()"
  >
    <span class="relative z-10 flex items-center"
      ><simple-svg
        :filepath="slide.icon"
        :width="'16px'"
        :height="'16px'"
        class="p-2 rounded-full mr-2"
        style="background-color: #fff4b3"
      />
      {{ slide.title }}</span
    >
  </a>
</template>

<script>
export default {
  props: ["slide", "isPaused"],

  data: function () {
    return {};
  },

  methods: {
    changeTab() {
      this.$emit("tabChanged", this.slide.id);
    },
  },
};
</script>

<style>
.btn--slider:hover {
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff4b3;
}

.btn--slider.active {
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff4b3;
}

.btn--slider::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform: scaleX(0);
  background-color: #ffef94;

  @apply rounded-lg;
}

.btn--slider.active::after {
  transform: scaleX(1);
  animation-name: progress;
  animation-direction: normal;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transform-origin: left;
  will-change: transform;
}

.btn--slider.active.paused::after {
  animation: none;
  transform: scaleX(1);
}

@keyframes progress {
  0% {
    transform: scaleX(0);
  }

  100% {
    transform: scaleX(1);
  }
}
</style>
